import { render, staticRenderFns } from "./XCPage.vue?vue&type=template&id=5ec49f42&scoped=true&"
import script from "./XCPage.vue?vue&type=script&lang=js&"
export * from "./XCPage.vue?vue&type=script&lang=js&"
import style0 from "./XCPage.vue?vue&type=style&index=0&id=5ec49f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec49f42",
  null
  
)

export default component.exports